export interface AiMaturityLevel {
  /** Position sur l'échelle (0 à 4) — pilote aussi la graduation de la barre. */
  value: number;
  name: string;
  caption: string;
}

export interface AiMaturityContent {
  label: string;
  title: string;
  paragraphs: readonly string[];
  levels: readonly AiMaturityLevel[];
  /** Position courante sur l'échelle 0–4 (ex. 2.5 = entre les étapes 2 et 3). */
  position: number;
  markerLabel: string;
  sourceNote: string;
}

export const AI_MATURITY: AiMaturityContent = {
  label: 'Pratique IA',
  title: 'Où j’en suis sur l’échelle de Boris Cherny',
  paragraphs: [
    'Le 16 juillet 2026, Boris Cherny — le créateur de Claude Code chez Anthropic — a publié une échelle en cinq niveaux qui décrit comment les développeurs adoptent les agents IA. Elle mesure une seule chose : la part du travail que l’on accepte de déléguer. Au bas de l’échelle, un humain relit chaque ligne que la machine produit ; à mesure que l’on monte, la supervision manuelle est remplacée par un système de vérification — tests, environnements isolés, relecture automatisée — qui permet de faire travailler toujours plus d’agents en parallèle. À chaque étape, le goulot n’est jamais la motivation : c’est ce système qu’il faut construire.',
    'Mon setup Claude Code me situe entre les étapes 2 et 3 : plusieurs agents en parallèle, chacun dans son environnement isolé, une boucle de vérification que l’agent lance lui-même — typecheck, lint, build — et une relecture qui porte sur les résultats, plus sur les frappes de clavier.',
  ],
  levels: [
    { value: 0, name: 'Accès verrouillé',  caption: 'L’outil est acheté, les processus bloquent' },
    { value: 1, name: 'Le binôme',          caption: 'Un humain, un agent, tout est supervisé' },
    { value: 2, name: 'L’orchestrateur', caption: 'Des agents en parallèle, relecture des résultats' },
    { value: 3, name: 'La centaine',        caption: 'Plus de surveillance ligne par ligne' },
    { value: 4, name: 'L’intention',     caption: 'Un millier d’agents, pilotage par intention pure' },
  ],
  position: 2.5,
  markerLabel: 'Ici — 2 → 3',
  sourceNote: 'Échelle publiée par Boris Cherny (Anthropic), juillet 2026.',
};
